module.exports = __webpack_public_path__ + "img/2006_L.f4e43fd6.png";